import { gql } from "@apollo/client";

// Asks the backend to stop an in-flight Ask AI response (TF-1512). The client
// also stops its own loading UI immediately, so this is best-effort cleanup:
// it tells the agent loop to persist its partial answer and stop burning
// tokens. Returns the session id only — the client doesn't read the response.
export default gql`
  mutation cancelAskAIMessageMutation($chatSessionId: Int!) {
    cancelChatbotSession(chatSessionId: $chatSessionId) {
      chatSession {
        id
      }
    }
  }
`;
